import axios from 'axios'
import config from 'config'
import { createAuthedHttpClient } from '@driftt/web-auth'
import Qs from 'qs'

axios.defaults.headers.post['Content-Type'] = 'application/json'

export const CustomerAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CUSTOMER_API,
    paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'}),
  }
})

export const ConversationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONVERSATION_API,
    paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
  }
})

export const GrowthAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.GROWTH_API,
    paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
  }
})

export const AccountsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ACCOUNTS_API,
  }
})

export const WSChatApi = axios.create({
  baseURL: config.WS_API,
})
